import { memo } from "react";

import { Icon } from "@react/components/Icon";
import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  handleOpenGiftNoteDrawer: () => void;
  hasPreviouslySavedGiftNote: boolean;
};

const styles = {
  giftNote: tw(
    "flex",
    "justify-between",
    "bg-background-primary",
    "px-6",
    "py-4",
    "border-0",
    "border-t",
    "border-b",
    "border-solid",
    "border-divider",
    "text-primary"
  ),
  giftNoteAddButton: tw(
    "flex",
    "items-center",
    "border-0",
    "bg-transparent",
    "cursor-pointer"
  ),
  giftNoteEditButton: tw(
    "flex",
    "items-center",
    "border-0",
    "bg-transparent",
    "cursor-pointer",
    "underline"
  ),
  giftNoteIcon: tw("mr-1", "h-4", "w-4"),
  giftNoteText: tw("grow"),
};

const CartGiftNoteStatusViewBase = ({
  handleOpenGiftNoteDrawer,
  hasPreviouslySavedGiftNote,
}: Props) => {
  return (
    <div className={styles.giftNote}>
      {hasPreviouslySavedGiftNote ? (
        <>
          <Icon className={styles.giftNoteIcon} name="checkmark" />
          <Text as="body2" className={styles.giftNoteText}>
            Gift Note Added!
          </Text>
          <button
            className={styles.giftNoteEditButton}
            onClick={handleOpenGiftNoteDrawer}
          >
            <Text as="body2">Edit</Text>
          </button>
        </>
      ) : (
        <>
          <button
            className={styles.giftNoteAddButton}
            onClick={handleOpenGiftNoteDrawer}
          >
            <Icon className={styles.giftNoteIcon} name="plus" />
            <Text as="body2">Add Gift Note</Text>
          </button>
        </>
      )}
    </div>
  );
};

export const CartGiftNoteStatusView = memo(CartGiftNoteStatusViewBase);
